import { Typography } from '@material-ui/core'
import React from 'react'
import { Control, FieldErrors } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { energyCapacityUnit, powerUnit } from '../../../../util/formatters'
import { validators } from '../../../../validation/validators'
import { ControlledTextField } from '../../../form/ControlledTextField'
import { FormGroup } from '../../../form/FormGroup'
import { InternalFormValues } from '../form-values'

type Props = {
  control: Control<InternalFormValues>
  errors: FieldErrors<InternalFormValues>
}

export function BatteryForm({ control, errors }: Props): React.ReactElement {
  const { t } = useTranslation()
  return (
    <>
      <FormGroup>
        <ControlledTextField
          control={control}
          name="parameters.battery.capacity"
          rules={{
            ...validators.required,
            ...validators.positiveInteger,
          }}
          error={errors.parameters?.battery?.capacity}
          label={t('createProvider.forms.battery.capacity')}
          InputProps={{
            endAdornment: <Typography>{energyCapacityUnit}</Typography>,
          }}
        />
      </FormGroup>
      <FormGroup>
        <ControlledTextField
          control={control}
          name="parameters.battery.chargePower"
          rules={{
            ...validators.required,
            ...validators.positiveInteger,
          }}
          error={errors.parameters?.battery?.chargePower}
          label={t('createProvider.forms.battery.chargePower')}
          InputProps={{
            endAdornment: <Typography>{powerUnit}</Typography>,
          }}
        />
      </FormGroup>
      <FormGroup>
        <ControlledTextField
          control={control}
          name="parameters.battery.dischargePower"
          rules={{
            ...validators.required,
            ...validators.positiveInteger,
          }}
          error={errors.parameters?.battery?.dischargePower}
          label={t('createProvider.forms.battery.dischargePower')}
          InputProps={{
            endAdornment: <Typography>{powerUnit}</Typography>,
          }}
        />
      </FormGroup>
    </>
  )
}
